import zigaImg from "../images/Ziga-FizioLeos.jpg";

const physios = {
  en: [
    {
      img: zigaImg,
      initials: "ŽO",
      name: "Žiga Oset",
      specialty: "Graduate physiotherapist specialized in orthopedic manual therapy.",
      email: "info@fizioleos.si",
      website: "fizioleos.si",
      tel:"+386 31 796 512",
      description:
        "I believe that good physiotherapy results require an individualized approach, where the techniques used and the pace of the rehabilitation process are tailored to the specific needs of each person. Revimo also helps me with this.",
      experienceLabel: "12 years experience",
    },
  ],
  sl: [
    {
      img: zigaImg,
      initials: "ŽO",
      name: "Žiga Oset",
      specialty: "Diplomiran fizioterapevt specializiran na področju ortopedske manualne terapije",
      email: "info@fizioleos.si",
      website: "fizioleos.si",
      tel:"+386 31 796 512",
      description:
        "Verjamem, da je za dober rezultat fizioterapije nujen individualen pristop, kjer se uporabljene tehnike in tempo rehabilitacijskega procesa prilagaja specifičnim potrebam posameznika. Pri čemer mi pomaga tudi Revimo.",
      experienceLabel: "12 let izkušenj",
    },
  ]
  // add more doctors later
};

export default physios;
